export default __webpack_public_path__ + "149a083f1554b469fa1000355e23f1ac.svg";